(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["spp-artboard-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
 const button=event.target.closest('.ab-product__gallery button[data-ab-image]');
 if(!button)return;
 const card=button.closest('.ab-product');
 const image=card.querySelector('.ab-product__image img');
 if(!image)return;
 image.src=button.dataset.abImage;
 image.removeAttribute('srcset');
 image.alt=button.dataset.abAlt;
 card.querySelectorAll('.ab-product__gallery button').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spp-clean-style"] && !Shopify.designMode) return;
  try {
    (function(){
 const allocate=()=>{
  const seen=new Set();
  document.querySelectorAll('spp-slot').forEach(slot=>{
   let cards=[...slot.querySelectorAll(':scope > spp-candidate')];
   let limit=Number(slot.dataset.limit)||4;
   const eligible=cards.filter(card=>!seen.has(card.dataset.productId));
   if(limit>3&&eligible.length===5)limit=4;
   let shown=0;
   cards.forEach(card=>{const id=card.dataset.productId;card.hidden=seen.has(id)||shown>=limit;if(!card.hidden){seen.add(id);shown++;}});
   if(shown&&slot.classList.contains('sp-product-grid'))slot.style.setProperty('grid-auto-columns',shown===1?'100%':shown===2?'calc((100% - 14px)/2)':shown===3&&matchMedia('(min-width:750px)').matches?'calc((100% - 28px)/3)':'');
  });
 };
 const init=()=>{
  allocate();
  document.querySelectorAll('.sp-carousel').forEach(carousel=>{
   const track=carousel.querySelector('.sp-product-grid');
   const prev=carousel.querySelector('[data-sp-prev]');const next=carousel.querySelector('[data-sp-next]');
   if(!track||!prev||!next)return;
   const update=()=>{prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;};
   update();
   if(carousel.dataset.bound)return;carousel.dataset.bound='1';
   prev.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'}));
   next.addEventListener('click',()=>track.scrollBy({left:track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'}));
   track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 ['shopify:section:load','shopify:section:unload','shopify:section:reorder'].forEach(name=>document.addEventListener(name,init));
})();
  } catch(e) { console.error(e); }
})();

})();
